export default "__VITE_ASSET__DYFvFdZt__"